var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M23.766 13.082c0-.816-.066-1.636-.207-2.438H12.24v4.62h6.482a5.56 5.56 0 0 1-2.399 3.647v2.999h3.867c2.271-2.09 3.576-5.177 3.576-8.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.24 24.807c3.237 0 5.966-1.063 7.955-2.897l-3.867-2.999c-1.076.732-2.465 1.147-4.083 1.147-3.131 0-5.786-2.112-6.738-4.952h-3.99v3.09a12 12 0 0 0 10.723 6.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M5.503 15.106a7.2 7.2 0 0 1 0-4.595v-3.09H1.517a12.01 12.01 0 0 0 0 10.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.24 5.555a6.52 6.52 0 0 1 4.603 1.8l3.427-3.427A11.53 11.53 0 0 0 12.24.806 12 12 0 0 0 1.517 7.42l3.986 3.091c.948-2.844 3.606-4.956 6.737-4.956"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .806h24v24H0z"
  })))));
};
export default SvgGoogle;